import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/use-toast';
import { Lock, Mail } from 'lucide-react';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      toast({
        title: "Login Successful",
        description: "Welcome back!",
      });
      navigate('/admin/dashboard');
    } catch (error) {
      toast({
        title: "Login Failed",
        description: error.message,
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  const logoUrl = 'https://customer-assets.emergentagent.com/job_jyoti-agency/artifacts/299sy1av_Logo%20%282%29.png';

  return (
    <div className="min-h-screen flex items-center justify-center hero-section px-4">
      <Card className="w-full max-w-md bg-white shadow-2xl rounded-3xl border-0">
        <CardHeader className="text-center pb-4">
          <img src={logoUrl} alt="Jyoti Web Design" className="h-24 mx-auto mb-4" />
          <CardTitle className="text-3xl font-bold text-gray-900">Admin Login</CardTitle>
          <p className="text-gray-600 mt-2">Access your dashboard</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email" className="text-lg font-semibold text-gray-800">
                <Mail className="w-5 h-5 inline mr-2" />
                Email
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2 border-2 rounded-lg text-lg p-6"
                placeholder="admin@example.com"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-lg font-semibold text-gray-800">
                <Lock className="w-5 h-5 inline mr-2" />
                Password
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2 border-2 rounded-lg text-lg p-6"
                placeholder="••••••••"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-gray-900 hover:bg-gray-800 text-white py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>
          <div className="mt-6 text-center">
            <Button
              variant="link"
              onClick={() => navigate('/')}
              className="text-gray-600 hover:text-gray-900"
            >
              ← Back to Website
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
